S.navMain =
    {
        config: {

            // delay beim sliddown click
            slideDownDelay: 300,

            // animationszeit beim sliddown click wenn 1 Layer bereits offen ist
            slideDownDelayOpenSlideFrom: 0,

            // delay slideup click
            slideUpDelay: 200,

            // slideFrom = horizontale Navi
            // sonst accordion untereinander (mobile)
            slideFrom: 'desktop',

            // delay des sliders wenn anderer bereits offen ist
            slideOpenDelay: 0,

            // ab slideFrom: delay des sliders wenn anderer bereits offen ist
            // sollte minimum slideUpDelay betragen
            slideOpenDelaySlideFrom: 0,

            // hover ab Mediaquery z.B. hoverFrom: desktop
            hoverFrom: null,

            // click accordion scroll top
            scrollTop: true,

            // mobile alles ausklappen (alles bevor slideFrom)
            // S.slide.openAllSlides(); im headerjs notwendig
            // openAllSlidesbeforeSlideFrom: true,
            openAllSlidesbeforeSlideFrom: false,

            // need js-m-scrolltop inside define scrollarea mobile for scrollTop Option
            // e.g scrollTopCointainer: #footer_navigation
            scrollTopCointainer: '#navigation',
        },

        elements: {
            // ggf bei hover parent element
            $slide: null,
            $slideHead: null,
            $slideContent: null,
            $arrow: null,
            $3rdNavigation: null,
            $2ndMenu: null,
        },

        init($module, config, elements)
        {
            let setdelay = 0;
            let slideDownTime = 0;
            const slide = elements.$slide;
            const head = elements.$slideHead;
            const content = elements.$slideContent;



            this.elements.$2ndMenu.mouseleave(() =>
            {
                if (S.mq('desktop').matches) {
                    this.elements.$3rdNavigation.removeClass('is-open');
                    this.elements.$arrow.removeClass('is-active');
                    this.elements.$arrow.parent().removeClass('is-active');
                    this.elements.$3rdNavigation.hide();
                }
            });

            // https://stackoverflow.com/questions/4817029/whats-the-best-way-to-detect-a-touch-screen-device-using-javascript
            // if(!this.isTouchDevice() && config.slideFrom && S.mq(config.slideFrom, true).matches) {
            // this.toggleKeyTab();
            // }

            // Link Tags nicht folgen wenn slides vorhanden
            const setPreventDefault = () =>
            {
                head.on('click tap', function (e)
                {
                    // Prevent default only when the arrow was clicked
                    if ($(e.target).hasClass('m-arrow'))
                    {
                        e.preventDefault();
                    }
                });
            };

            const activeHighlight = () =>
            {
                head.on('click tap', function (e)
                {
                    // Click on anchor should load the page
                    if (!$(e.target).hasClass('m-arrow'))
                    {
                        return;
                    }

                    head.removeClass('is-active-click');
                    if ($(this).next('.js-slide-content').is(':hidden'))
                    {
                        $(this).addClass('is-active-click');
                    }
                });
            };

            // allowOpenSlide
            const allowOpenSlide = () =>
            {
                if (config.openAllSlidesbeforeSlideFrom === true)
                {
                    if (config.slideFrom && S.mq(config.slideFrom, false).matches)
                    {
                        return true;
                    }
                }
                else
                {
                    return true;
                }

                return false;
            };


            // location.href
            const locationHref = (url) =>
            {
                setTimeout(function ()
                {
                    location.href = url.attr('href');
                }, config.slideUpDelay);
            };


            // close slide
            const closeSlide = (slidecontent) =>
            {
                slidecontent.stop().slideUp(config.slideUpDelay);

                setTimeout(function ()
                {
                    $('#navigation').removeClass('is-menue-open');
                }, 10);
            };


            // open slide
            const openSlide = (slidecontent) =>
            {
                if ($('#navigation').hasClass('is-menue-open'))
                {
                    slideDownTime = config.slideDownDelay;
                    if (config.slideFrom && S.mq(config.slideFrom, false).matches)
                    {
                        slideDownTime = config.slideDownDelayOpenSlideFrom;
                    }
                }
                else
                {
                    slideDownTime = config.slideDownDelay;
                }

                if (content.is(':visible'))
                {
                    setdelay = config.slideOpenDelay;
                    if (config.slideFrom && S.mq(config.slideFrom, false).matches)
                    {
                        setdelay = config.slideOpenDelaySlideFrom;
                    }
                }
                else
                {
                    setdelay = config.slideOpenDelay;
                }

                // close open slides
                // if (config.closeOpenSlides === true) (gibt zuviele Probleme)

                content.stop().slideUp(config.slideUpDelay);

                // scrolltop

                // alert($(window).height());
                if (content.is(':visible') && $(window).scrollTop() > ($(window).height()))
                {
                    // $('html').animate({
                    //     scrollTop: $module.position().top,
                    // }, config.slideUpDelay);
                }

                if (config.scrollTop)
                {
                    $(config.scrollTopCointainer + ' .js-m-scrolltop').animate({
                        scrollTop: 0,
                    }, config.slideUpDelay);
                }


                // open clicked slide
                slidecontent.stop().height('auto').delay(setdelay).slideDown(slideDownTime);

                setTimeout(function ()
                {
                    $('#navigation').addClass('is-menue-open');
                }, 20);
            };


            // initSlidesClick
            const initSlidesClick = () =>
            {
                // standard immer per click
                head.on('click tap', function (e)
                {
                    // Click on anchor should load the page
                    if (!$(e.target).hasClass('m-arrow'))
                    {
                        return;
                    }

                    const actContent = $(this).next('.js-slide-content');

                    // open
                    if (actContent.is(':hidden'))
                    {
                        // open act slide
                        openSlide(actContent);
                    }

                    // close
                    else if (actContent.is(':visible'))
                    {
                        if (allowOpenSlide() === true)
                        {
                            closeSlide(content);
                        }
                    }

                    // close all + redirect
                    else
                    {
                        // no act slide exist, close all open slides
                        // if ($(this).next().hasClass('js-slide-content') === false)
                        if (allowOpenSlide() === true)
                        {
                            closeSlide(content);
                        }

                        locationHref($(this));
                    }
                });
            };

            // initSlidesHover
            const initSlidesHover = () =>
            {
                slide.hover(
                    function ()
                    {
                        head.removeClass('is-active-click');
                        const actContent = $(this).children('.js-slide-content');
                        const actContent3dLvl = $(this).children('.js-3rd-navigation');

                        // open
                        if (actContent.is(':hidden'))
                        {
                            // open act slide
                            openSlide(actContent);
                        }

                        // close
                        else if (actContent.is(':visible'))
                        {
                            if (allowOpenSlide() === true)
                            {
                                closeSlide(actContent);
                            }
                        }

                        // open 3 lvl
                        if (actContent3dLvl.is(':hidden'))
                        {
                            // open act slide
                            actContent3dLvl.closest('.js-slide').addClass('is-open');
                            openSlide(actContent3dLvl);
                        }

                        // close 3 lvl
                        actContent3dLvl.closest('.js-slide.is-open').siblings().hover(() =>
                        {
                            if ($(window).width() > 1024) {
                                closeSlide(actContent3dLvl);
                                actContent3dLvl.closest('.js-slide.is-open').removeClass('is-open');
                            }
                        });
                    },
                    function ()
                    {
                        if (allowOpenSlide() === true)
                        {
                            closeSlide(content);
                        }
                    },
                );

                // standard immer per click
                head.on('click tap', function ()
                {
                    const actContent = $(this).next('.js-slide-content');
                    const href = ($(this).attr('href'));
                    // js link only

                    if (href.indexOf('/') === -1)
                    {
                        // open
                        if (actContent.is(':hidden'))
                        {
                            // alert(':hidden');
                            // open act slide
                            openSlide(actContent);
                        }
                        // close
                        else if (actContent.is(':visible'))
                        {
                            // if (allowOpenSlide() === true)
                            {
                                closeSlide(content);
                            }
                        }
                    }
                });
            };

            // initSlides
            const initSlides = () =>
            {
                slide.unbind('mouseenter mouseleave click hover tap');
                head.unbind('mouseenter mouseleave click hover tap');

                // hover ab z.B Desktop....
                if (config.hoverFrom && S.mq(config.hoverFrom, false).matches)
                {
                    head.removeClass('is-active-click');
                    content.hide();

                    initSlidesHover();
                }
                // click
                else
                {
                    initSlidesClick();

                    // Links nicht folgen sondern JS ausführen slide open/close
                    setPreventDefault();
                }
            };


            // open/close click or hover slides init
            initSlides();

            // set Highlicht
            activeHighlight();


            // close Slides by outside click
            // auch z.B menue icon oeffnen
            $(document).on('click tap', function (e)
            {
                if (!$(e.target).closest($module).length)
                {
                    if (allowOpenSlide() === true)
                    {
                        closeSlide(content);
                        head.removeClass('is-active-click');
                    }
                }
            });


            // window resize
            $(window).on('resize', () =>
            {
                S.delayed('resizeSlide', 250, () =>
                {
                    initSlides();
                    activeHighlight();
                });
            });

            this.toggleKeyTab();
            this.subMenuMobile();
        },

        XXisTouchDevice()
        {
            return typeof window.ontouchstart !== 'undefined';
        },

        toggleKeyTab()
        {
            const $slideHead = this.elements.$slideHead;
            const $slideContent = this.elements.$slideContent;
            const slideFrom = this.config.slideFrom;

            $slideHead.on('focus', () =>
            {
                if (slideFrom && S.mq(slideFrom, true).matches)
                {
                    $slideHead.removeClass('is-focus');
                    $slideHead.removeClass('is-active-click');
                    $slideContent.hide();
                }
            });

            // Keysteuerung
            $slideHead.on('keydown', (e) =>
            {
                const actContent = $(e.currentTarget).next('.js-slide-content');

                if (e.keyCode === 13 || e.which === 32)
                // leer oder return
                // if (e.keyCode === 13 || e.keyCode === 32)
                {
                    // open act slide
                    $slideContent.hide();

                    setTimeout(function ()
                    {
                        actContent.show();
                    }, 25);
                }
                else if (e.keyCode === 27)
                // escape
                {
                    actContent.hide();

                    // $(e.currentTarget).focus(); check focus after escape geht so nicht
                    setTimeout(function ()
                    {
                        $(e.currentTarget).removeClass('is-active-click');
                        $('body').addClass('is-keyboard-focus');
                        $(e.currentTarget).addClass('is-focus');
                    }, 25);
                }
            });

            // check qs
            // Keysteuerung escape
            $('.js-slide-content a').on('keydown', (e) =>
            {
                const actContent = $(e.currentTarget).closest('.js-slide-content');
                const actHead = actContent.prev('.js-slide-head');

                if (e.keyCode === 27)
                {
                    this.$module.find('.js-slide-head').removeClass('is-active-click');
                    actContent.hide();
                    actHead.focus();
                }
            });
        },

        // open all slides
        openAllSlides()
        {
            this.elements.$slideContent.show();
            setTimeout(function ()
            {
                $('#navigation').addClass('is-menue-open');
            }, 10);
        },

        close()
        {
            this.elements.$slideContent.stop().slideUp(this.config.slideUpDelay);
            this.elements.$slideHead.removeClass('is-active-click');
        },

        hide()
        {
            this.elements.$slideContent.stop().hide();
            this.elements.$slideHead.removeClass('is-active-click');
        },

        subMenuMobile()
        {
            if (!S.mq('desktop').matches)
            {
                this.elements.$arrow.click(function (e)
                {
                    e.preventDefault();
                    e.stopPropagation();
                    $(this).parent().next().toggle('slow');
                    $(this).toggleClass('is-active');
                    $(this).parent().toggleClass('is-active');
                });
            }
        },
    };
